import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  MetricTableVizConfig,
  MetricTableVizExternalProps,
  MetricTableVizViews,
} from './types';
import { useMetricTableConfigToData } from './useConfigToData';
import { metricTableViewConfigs } from './views/view-configs';

export interface MetricTableVizProps {
  dataConfig: MetricTableVizConfig;
  selectedView?: MetricTableVizViews;
  externalProps: MetricTableVizExternalProps;
  persistenceKey: string;
}

/**
 * A visualization component that displays a table of metric values.
 *
 * Each cell in the table is a separate metric query:
 * - Specify headers for columns
 * - Specify rows with labels and an array of metrics (or null for empty cells)
 * - All metrics are fetched in parallel
 * - Values are displayed in the corresponding cells
 *
 * Use this when you need a structured table view of multiple related metrics.
 */
export const MetricTableViz = (props: MetricTableVizProps) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useMetricTableConfigToData}
      selectedView={props.selectedView ?? MetricTableVizViews.TABLE}
      viewConfigs={metricTableViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
